import React from 'react';

const PaginationComponent = ({ currentPage, totalPages, paginationEvent }) => {
  const pageNumbers = [];
  // const paginationWindow = 1
  // var mainPage = []

  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  // var maxLeft = (currentPage - Math.floor(paginationWindow / 2))
  // var maxRight = (currentPage + Math.floor(paginationWindow / 2))

  // if (maxLeft < 1) {
  //   maxLeft = 1
  //   maxRight = paginationWindow
  // }

  // if (maxRight > pageNumbers) {
  //   maxLeft = pageNumbers - (paginationWindow - 1)
  //   if (maxLeft < 1) {
  //     maxLeft = 1
  //   }
  //   maxRight = pageNumbers
  // }

  // for (var page = maxLeft; page <= maxRight; page++) {
  //   mainPage.push(page)
  // }
  var lastPage = totalPages - 1
  var firstButtonColor = currentPage === 1 ? '#B4B7C1' : '#0168FA'
  var lastButtonColor = currentPage === pageNumbers[lastPage] ? '#B4B7C1' : '#0168FA'

  let pageDropDown = [];
  for (let number = 1; number <= totalPages; number++) {
    pageDropDown.push(
      <li key={number} className={`page-link  mb-1  ${number === currentPage ? "active" : "bg-white"}`} style={{ width: "15px", borderColor: "#ffffff" }}>
        <a onClick={(e) => paginationEvent(e, number)} href='javascript:void(0)' className={`w-100 h-100 d-flex justify-content-center ${number === currentPage ? "text-white" : "d-flex justify-content-center"}`}>
          {number}
        </a>
      </li>)
  }

  return (<>
    {totalPages === 1 ? null :
      <nav>
        <ul className='pagination pagination-space justify-content-end pagination-sm'>
          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <a className="page-link page-link-icon" onClick={(e) => paginationEvent(e, 1)} href="javascript:void(0)" style={{ cursor: 'pointer' }}>First</a>
          </li>
          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <a className="page-link page-link-icon" id='previousPage' onClick={(e) => paginationEvent(e, currentPage)} href="javascript:void(0)"><i style={{ color: firstButtonColor }} className="fas fa-chevron-left" id='previousPage'></i></a>
          </li>
          <li className="page-item active">
            <div className="">
              <button className='btn-sm btn btn-white  dropdown-toggle page-link page-link-icon' type="button" role='button' data-toggle="dropdown">{currentPage}</button>
              <div className="dropdown-menu" role="menu" style={{
                minWidth: "auto", lineHeight: "100px",
                height: "145px",
                paddingTop: "0px", overflowY: "scroll"
              }}>
                <div className="li-conatiner">
                  {pageDropDown}
                </div>
              </div>
            </div>
          </li>
          <li className={`page-item ${currentPage === pageNumbers[lastPage] ? "disabled" : ""}`}>
            <a className="page-link page-link-icon" id='nextPage' onClick={(e) => paginationEvent(e, currentPage)} href="javascript:void(0)"><i style={{ color: lastButtonColor }} className="fas fa-chevron-right" id='nextPage'></i></a>
          </li>
          <li className={`page-item ${currentPage === pageNumbers[lastPage] ? "disabled" : ""}`}>
            <a className="page-link page-link-icon" onClick={(e) => paginationEvent(e, pageNumbers[lastPage])} href="javascript:void(0)" style={{ cursor: 'pointer' }}>Last</a>
          </li>
        </ul>
      </nav>}
  </>);
};

export default PaginationComponent;